import { render } from "./idcardTypeSelect.vue?vue&type=template&id=6a04ff1b"
import script from "./idcardTypeSelect.vue?vue&type=script&lang=js"
export * from "./idcardTypeSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__